import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from '@truefit/http-utils';

import {
  TRANSCODING_PROFILES_QUERY_KEY,
  TRANSCODING_PROFILES_URL,
  type TranscodingProfile,
} from './useTranscodingProfilesQuery';
import { type TranscodingProfileInput } from './useCreateTranscodingProfileMutation';

export interface UpdateTranscodingProfileProps extends TranscodingProfileInput {
  id: number;
}

export const useUpdateTranscodingProfileMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      ...input
    }: UpdateTranscodingProfileProps): Promise<TranscodingProfile> => {
      const { data } = await put<TranscodingProfile>(
        `${TRANSCODING_PROFILES_URL}/${id}`,
        input,
      );
      return data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: TRANSCODING_PROFILES_QUERY_KEY }),
  });
};

export default useUpdateTranscodingProfileMutation;
